module.exports = __webpack_public_path__ + "static/media/NXP-Logo.svg.1b3ad1c4.png";